/// <amd-module name="Wit/Common/Utils/TeamSettingsPanel/TeamSettingsPanelButton" />
import * as React from "react";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssLayoutManager, WrappedComponent } from "VSS/Platform/Layout";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { ITeamSettingsPanelProps } from "Wit/Common/TeamSettingsPanel/Components/TeamSettingsPanel.Props";
import * as Resources from "Wit/Common/Utils/TeamSettingsPanel/Resources";

export function getTeamSettingsCommandBarButton(
    pageContext: IVssPageContext,
    teamSettingsPanelProps: ITeamSettingsPanelButtonProps,
    rank?: number
): IHeaderCommandBarItem {
    const settingsButton: IHeaderCommandBarItem = {
        ariaLabel: Resources.ConfigureTeamSettings,
        iconProps: { iconName: "Settings" },
        id: "team-settings",
        important: true,
        onActivate: () => onActivate(pageContext, teamSettingsPanelProps),
        rank,
        subtle: true,
        tooltipProps: { text: Resources.ConfigureTeamSettings }
    };

    return settingsButton;
}

function onActivate(pageContext: IVssPageContext, teamSettingsPanelProps: ITeamSettingsPanelButtonProps) {
    pageContext.getService<IVssLayoutManager>("IVssLayoutManager").renderCallout(onDismiss => (
        <WrappedComponent<ITeamSettingsPanelProps>
            dependencies={["ms.vss-work-web.team-settings-panel"]}
            wrappedType={"ms.vss-work-web.team-settings-panel-component"}
            wrappedProps={{
                ...teamSettingsPanelProps,
                onDismiss: () => {
                    teamSettingsPanelProps.onDismiss && teamSettingsPanelProps.onDismiss();
                    onDismiss();
                }
            }}
        />
    ));
}

export interface ITeamSettingsPanelButtonProps extends Omit<Partial<ITeamSettingsPanelProps>, "teamId">, Pick<ITeamSettingsPanelProps, "teamId"> {}
